import { WeighedDataToBatch } from '../../containers/Batch/DataToBatch';
import logger from '../../utils/logger';
import RootStore from '../root-store';

/**
 * Skip feed for this device – jump to next on the same scale
 * Go back to feed mode for this device after the next one is done
 */
export const deferFeedBin = (rootStore: RootStore, binId: string) => {
  logger.log('Deferring feed for bin: ', binId);
  const { batchStore } = rootStore;

  const primaryBin = batchStore.devicesStore.getDeviceById(binId);
  const primaryBinStatus = batchStore.getDeviceStatus(binId);
  const scaleId = primaryBin?.scaleId;

  if (!scaleId) {
    logger.warn('No scale id found for device: ', binId);
    return;
  }

  if (!batchStore.deferredFeedDevices.has(scaleId)) {
    batchStore.deferredFeedDevices.set(scaleId, new Map());
  }

  if (
    batchStore.deferredFeedDevices.get(scaleId).has(binId)
  ) {
    return;
  }

  // Find the runningData for this device
  const runningData = batchStore.running.find((runningData) =>
    runningData.uid === primaryBinStatus.uid && runningData.currentDrop === primaryBinStatus.currentDrop,
  );
  if (!runningData) {
    logger.warn('No running data found for device: ', binId);
    return;
  }

  const scaleData = runningData.scales[scaleId];
  if (!scaleData) {
    logger.warn('No scale data found for device: ', binId);
    return;
  }

  const currentWeighedDataIndex = scaleData.findIndex(
    (weighedDataToBatch: WeighedDataToBatch) => {
      if (!weighedDataToBatch.bin) {
        return false;
      }

      return weighedDataToBatch.bin.id === binId;
    },
  );

  if (currentWeighedDataIndex === -1) {
    logger.warn('Device not found in scale data: ', binId);
    return;
  }

  const [currentWeighedData] = scaleData.splice(currentWeighedDataIndex, 1);

  currentWeighedData.isFeedInterrupted = true;

  // Get primary and secondary bins
  const bins = batchStore.getBins(currentWeighedData);
  const secondaryBin = bins.secondaryBin;

  // Store the current weight for the deferred device
  batchStore.deferredFeedDevices.get(scaleId).set(binId, primaryBinStatus.weight);
  if (secondaryBin) {
    const secondaryBinStatus = batchStore.getDeviceStatus(secondaryBin.id);
    batchStore.deferredFeedDevices.get(scaleId).set(secondaryBin.id, secondaryBinStatus.weight);
  }

  // Insert after the next weighed data
  scaleData.splice(currentWeighedDataIndex + 1, 0, currentWeighedData);

  // Kick off the next bin immediately
  batchStore.batchDataForScale(scaleId, runningData);
};

